<template>
  <TenderStep
    :current-step="currentStep"
    :total-steps="totalSteps"
    :error-transition="false"
  >
    <template slot="header">
      <div class="text-base font-normal text-[#4a4a4a]">
        {{ $t("requestTender.city.header") }}
      </div>
      <div class="question-big">
        {{ $t("requestTender.city.question") }}
      </div>
    </template>

    <template slot="subHeader">
      {{ $t("requestTender.city.subHeader") }}
    </template>

    <section>
      <div class="relative">
        <AutocompleteCity
          ref="cityAutocomplete"
          v-model="newTender.city.value"
          :placeholder="$t('requestTender.city.placeholder')"
          :show-error-msg="false"
          :validation-state="cityValidation"
          autofocus
          hide-down-icon
          @select="newTender.saveToStorage"
          @blur="cityValidation.$touch()"
          @keyup.enter.exact.native="emitNext('enter')"
        >
          <template #empty>
            {{ $t("requestTender.city.autocomplete.empty") }}
          </template>
        </AutocompleteCity>
        <span
          v-if="!cityValidation.$invalid"
          class="absolute right-3 top-1/2 -translate-y-1/2 text-positive pointer-events-none"
        >
          <IconComponent class="fa-lg" icon="check" />
        </span>
      </div>
    </section>

    <template slot="error">
      <div v-if="cityValidation.$error">
        {{ cityValidation.$errors[0]?.$message }}
      </div>
    </template>

    <template slot="footer">
      <WizardNextButton
        :disabled="cityValidation.$invalid"
        @click="emitNext()"
      />
    </template>
  </TenderStep>
</template>

<script>
import { toRefs } from "@nuxtjs/composition-api";
import WizardNextButton from "./WizardNextButton.vue";
import TenderStep from "@/components/TenderStep";
import AutocompleteCity from "~/components/_refactored/autocomplete/AutocompleteCity.vue";
import { useNewTender } from "~/composables/tender/useNewTender";
import { useTrackWizardClick } from "~/composables/tracking/useTrackWizardClick";

export default {
  name: "CityStepModule",
  components: { TenderStep, AutocompleteCity, WizardNextButton },
  props: {
    currentStep: { type: Number, required: true },
    totalSteps: { type: Number, required: true },
    moduleSlug: { type: String, default: "city" },
  },
  emits: ["next"],
  setup(props) {
    const { trackNextAttempt } = useTrackWizardClick(toRefs(props));
    return { trackNextAttempt, newTender: useNewTender() };
  },
  computed: {
    // The autocomplete's v-model is the city OBJECT, so the global `required`
    // rule replaces the old vee-validate `cityOf` name-list matching (and the
    // prefilled-city list-append hack that came with it).
    cityValidation() {
      return this.newTender.v$.value.city;
    },
  },
  methods: {
    emitNext(trigger = "click") {
      this.trackNextAttempt({
        trigger,
        disabled: this.cityValidation.$invalid,
      });
      if (this.cityValidation.$invalid) {
        this.cityValidation.$touch();
        return;
      }
      this.newTender.saveToStorage();
      this.$emit("next", { field: "city" });
    },
  },
};
</script>
